import { render, staticRenderFns } from "./GStudentRecordCompetencyComparison.vue?vue&type=template&id=1d95e8cc&scoped=true&"
import script from "./GStudentRecordCompetencyComparison.vue?vue&type=script&lang=ts&"
export * from "./GStudentRecordCompetencyComparison.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d95e8cc",
  null
  
)

export default component.exports